module.exports = __webpack_public_path__ + "static/media/ios-flash-off.d6a9695f.svg";